import { createSelector } from 'reselect';
import { IState } from '../services/root-reducer';
import { WithOptionalState } from './with-optional-state';
import { getCachedPubContainers, getCachedFullContainers } from './omjs';


export const getChildren = WithOptionalState(
    (state: IState, parentId: number, deep = false) => {
        let childs = state.operations.CONTAINERS.data.filter(cont => cont.parent_id === parentId);
        if (deep) {
            for (let child of childs) {
                if (child.type === 'folder') {
                    childs = [ ...childs, ...getChildren(state, child.id, deep) ];
                }
            }
        }
        return childs;
    }
);

export const getRoots = createSelector(
    state => getCachedPubContainers(false),
    containers => containers.filter(cont => cont.get('parent_id') === 0)
);

export const getHints = WithOptionalState(
    (state: IState) => {
        const containers = getCachedFullContainers(state);
        const hintsContainer = containers.find(cont => cont.get('code') === 'hints');
        return hintsContainer.objects.getArray();
    }
);
